var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.167 5.834h3.666a4.643 4.643 0 009 0h13a1.166 1.166 0 100-2.334h-13a4.643 4.643 0 00-9 0H1.167a1.166 1.166 0 100 2.334zm8.166-3.5a2.334 2.334 0 110 4.667 2.334 2.334 0 010-4.667zM1.166 15.167h13a4.643 4.643 0 009.001 0h3.666a1.166 1.166 0 100-2.333h-3.666a4.643 4.643 0 00-9 0h-13a1.166 1.166 0 100 2.333zm17.5-3.5a2.334 2.334 0 110 4.667 2.334 2.334 0 010-4.667zM1.166 24.5h3.667a4.643 4.643 0 009 0h13a1.166 1.166 0 100-2.333h-13a4.643 4.643 0 00-9 0H1.166a1.166 1.166 0 100 2.333zM9.333 21a2.334 2.334 0 110 4.668 2.334 2.334 0 010-4.668z",
    fill: "#fff"
  })));
}
export default SvgIcnOrganization;